// Minimal i18n for the walking skeleton. The full ~36-key dictionary from v1
// index.html is ported in Phase 3; language detection semantics (URL param →
// localStorage 'karate-jump-lang' → browser) match v1.

export type Lang = 'en' | 'de';

const STRINGS = {
  en: {
    title: 'Karate Jump',
    tapToStart: 'Tap or press Enter to start',
    score: 'Score',
    distance: 'Distance',
    gameOver: 'Game Over',
    newRecord: 'NEW RECORD!',
    restart: 'Run again',
    paused: 'Paused',
    resumeHint: 'Press P or Escape to resume',
    secondWind: 'SECOND WIND!',
    combatBlock: 'BLOCK',
    combatCounter: 'COUNTER',
    combatDodge: 'DODGE',
    combatBlockPrompt: 'Block the attack!',
    combatCounterPrompt: 'Counter now!',
    combatDodgePrompt: 'Dodge! (jump)',
    combatWin: 'VICTORY!',
    combatLose: 'HIT!',
    senseiIntro: 'SENSEI TRIAL!',
    belt: 'BELT',
    shop: 'Dojo Shop',
    daily: 'Daily Challenge',
    best: 'Best Runs',
    buy: 'Buy',
    equip: 'Equip',
    equipped: 'Equipped',
    owned: 'Owned',
    back: 'Back',
    initials: 'Initials',
    save: 'Save',
    todaysBest: "Today's best",
    playDaily: 'GO!',
    coins: 'Coins',
  },
  de: {
    title: 'Karate Jump',
    tapToStart: 'Tippen oder Enter drücken zum Starten',
    score: 'Punkte',
    distance: 'Distanz',
    gameOver: 'Game Over',
    newRecord: 'NEUER REKORD!',
    restart: 'Nochmal laufen',
    paused: 'Pausiert',
    resumeHint: 'P oder Escape zum Fortsetzen',
    secondWind: 'SECOND WIND!',
    combatBlock: 'BLOCKEN',
    combatCounter: 'KONTERN',
    combatDodge: 'AUSWEICHEN',
    combatBlockPrompt: 'Blocke den Angriff!',
    combatCounterPrompt: 'Jetzt kontern!',
    combatDodgePrompt: 'Ausweichen! (springen)',
    combatWin: 'SIEG!',
    combatLose: 'TREFFER!',
    senseiIntro: 'SENSEI-PRÜFUNG!',
    belt: 'GURT',
    shop: 'Dojo-Shop',
    daily: 'Tages-Challenge',
    best: 'Bestenliste',
    buy: 'Kaufen',
    equip: 'Anlegen',
    equipped: 'Angelegt',
    owned: 'Gekauft',
    back: 'Zurück',
    initials: 'Initialen',
    save: 'Speichern',
    todaysBest: 'Heutige Bestleistung',
    playDaily: 'LOS!',
    coins: 'Münzen',
  },
} as const;

export type StringKey = keyof (typeof STRINGS)['en'];

export function detectLang(): Lang {
  const param = new URLSearchParams(window.location.search).get('lang');
  if (param === 'de' || param === 'en') return param;
  const stored = localStorage.getItem('karate-jump-lang');
  if (stored === 'de' || stored === 'en') return stored;
  return navigator.language.startsWith('de') ? 'de' : 'en';
}

export function makeTranslate(lang: Lang): (key: StringKey) => string {
  return (key) => STRINGS[lang][key];
}
